import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import { getRecordType } from '@/common/recordTypes';
import { CAA, QueryResult, RecordInfo } from '@/model/Api';

type CaaRecordWithInfo = {
  record: CAA;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'CaaRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const recordType = getRecordType('CAA');

const processedRecords = computed(() => {
  const processed: CaaRecordWithInfo[] = props.records.response.answer.filter((item): item is CaaRecordWithInfo => item.record.recordType === recordType.upper);
  return processed;
});

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { style: {"width":"20%"} }),
            _createElementVNode("col", { style: {"width":"20%"} }),
            _createElementVNode("col", { style: {"width":"30%"} }),
            _createElementVNode("col", { style: {"width":"30%"} })
          ], -1)),
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Flags"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Tag"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Value"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", null, _toDisplayString(record.record.flags), 1),
                _createElementVNode("td", null, _toDisplayString(record.record.tag), 1),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(record.record.value) + " ", 1),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.value,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, "No " + _toDisplayString(_unref(recordType).plural) + " found.", 1))
}
}

})